var _defs, _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _g, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f4c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1f7d3a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "40%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd54f",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffd54f",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#glow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 60 C 290 70 330 90 360 130 C 395 175 410 210 395 250 C 380 285 350 305 330 340 C 315 365 295 380 280 360 C 265 345 250 320 240 295 C 215 270 195 245 200 215 C 205 180 215 145 225 115 C 230 90 235 70 250 60 Z",
    fill: "#a5d6a7",
    stroke: "#fff",
    strokeWidth: 3,
    opacity: 0.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 160,
    r: 8,
    fill: "#ff5252",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 220,
    r: 8,
    fill: "#ff5252",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 280,
    r: 8,
    fill: "#ff5252",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 180,
    r: 8,
    fill: "#ffd54f",
    stroke: "#fff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,90)",
    fill: "#ffd54f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 6,
    ry: 14
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -10,
    cy: 6,
    rx: 5,
    ry: 12,
    transform: "rotate(-25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 6,
    rx: 5,
    ry: 12,
    transform: "rotate(25)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 40,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "Mappy \u2014 Crop Atlas")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 380,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#e8f5e9"
  }, "Click any district \xB7 Soil \xB7 Weather \xB7 KVK")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappy);
export default __webpack_public_path__ + "static/media/mappy.96bdb1388ca858f8d8f4c498caef3a6f.svg";
export { ForwardRef as ReactComponent };